import { TSimpleReviewCount } from '@/entities/room'

import { SubHeading } from '../common'

type Props = {
  hostSimpleReview: TSimpleReviewCount[]
}

export const Review = ({ hostSimpleReview }: Props) => {
  const hasReview = hostSimpleReview.length > 0

  if (!hasReview) {
    return null
  }

  return (
    <div className="space-y-3">
      <SubHeading className="typo-body2">호스트가 받은 후기</SubHeading>
      <ul className="space-y-2">
        {hostSimpleReview.slice(0, 2).map(review => (
          <li key={review.simpleReviewTemplateId}>
            <div className="bg-gray-0 flex items-center justify-between rounded-sm p-4">
              <span className="typo-label1 font-normal text-gray-900">
                {review.content}
              </span>
              <span className="typo-body2 font-semibold text-black">
                {review.count}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
